module.exports = __webpack_public_path__ + "img/welcomes-preview-text-vip-2.87a52e1b.png";